import { DocumentsEntryType } from "@components/dynamic/DocumentStatusList";
import {
    PROVIDER_RECIBE_MOTIVO_ABONO_PREFIX,
    PROVIDER_RECIBE_MOTIVO_ABONO_SEPARATOR,
    PROVIDER_RECIBE_MOTIVO_PREFIX,
    RECIBE_DOCUMENT_BUY_INVOICE_TYPE_KEY,
    RECIBE_DOCUMENT_ID_INDEX,
    RECIBE_DOCUMENT_PROVIDER_INVOICE_TYPE_KEY,
    RECIBE_DOCUMENT_TYPE_INDEX,
    RECIBE_TYPE_NUMBER_SEPARATOR,
} from "./Constants";

/** Documentos del estado de cuenta del proveedor que pueden recibir un abono. */
export const PAYABLE_PROVIDER_DOCUMENT_KINDS: DocumentsEntryType["kind"][] = ["providerInvoice", "buyInvoice"];

export type AbonoDocumentKind = "providerInvoice" | "buyInvoice";

/**
 * Clave con la que el select del recibo identifica al documento del abono:
 * `pi##<id>` para una factura de proveedor y `bi##<id>` para una factura
 * electronica de compra. El tipo decide en cual de los dos modelos de abono
 * (`ProviderInvoicePayment` o `BuyInvoicePayment`) se escribe.
 */
export const buildAbonoDocumentKey = (kind: DocumentsEntryType["kind"], id?: string | null): string => {
    const typeKey = kind == "buyInvoice"
        ? RECIBE_DOCUMENT_BUY_INVOICE_TYPE_KEY
        : RECIBE_DOCUMENT_PROVIDER_INVOICE_TYPE_KEY;
    return `${typeKey}${RECIBE_TYPE_NUMBER_SEPARATOR}${id}`;
};

export const parseAbonoDocumentKey = (key?: string | null): { kind: AbonoDocumentKind, id: string } => {
    const parts = `${key || ""}`.split(RECIBE_TYPE_NUMBER_SEPARATOR);
    return {
        kind: parts[RECIBE_DOCUMENT_TYPE_INDEX] == RECIBE_DOCUMENT_BUY_INVOICE_TYPE_KEY
            ? "buyInvoice"
            : "providerInvoice",
        id: `${parts[RECIBE_DOCUMENT_ID_INDEX] || ""}`,
    };
};

export const buildAbonoDocumentOptions = (selectedDocuments: DocumentsEntryType[]): Record<string, string> => {
    return selectedDocuments
        .filter(d => PAYABLE_PROVIDER_DOCUMENT_KINDS.includes(d.kind))
        .reduce((a, d) => {
            return {
                ...a,
                [buildAbonoDocumentKey(d.kind, `${d.data.id}`)]: d.kind == "buyInvoice"
                    ? `FEC-${d.data.numero}`
                    : `Factura #${d.data.numero}`
            }
        }, {} as Record<string, string>);
};

/**
 * El motivo sigue listando unicamente las facturas que quedaron pagadas por completo,
 * porque `parseMotivoReferences` lo usa para reparar los recibos sin ligar. El detalle
 * del abono va despues del separador, que ese parser descarta.
 */
export const buildProviderRecibeMotivo = (fullPayNumeros: string[], abonoNumero?: string): string => {
    const paidPart = fullPayNumeros.length > 0
        ? `${PROVIDER_RECIBE_MOTIVO_PREFIX}${fullPayNumeros.join(" , ")}`
        : "";
    if (!abonoNumero) {
        return paidPart;
    }
    const abonoPart = `${PROVIDER_RECIBE_MOTIVO_ABONO_PREFIX}${abonoNumero}`;
    return paidPart
        ? `${paidPart}${PROVIDER_RECIBE_MOTIVO_ABONO_SEPARATOR}${abonoPart}`
        : abonoPart;
};
